import React from 'react';
import './Map.css';

export default function Map() {
  return (
    <div className="map-container">
      <iframe
      title="Sammarshya Technologies Location Map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30259.992552903273!2d73.75904071083988!3d18.551525700000013!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2674372c4e506c13%3A0x73dd94e09dd34de3!2sSammarshya%20Technologies%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1735033773805!5m2!1sen!2sin"
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}
